import React from "react";
import {Pagination} from "antd";
import {GeneratorGet} from "../models/generator";
import {BillToList, BillToPost} from "../models/billto";

export const UserContext = React.createContext();

export const Role = (props) => {
  if (!props.isReverse) {
    if (props.allow.includes(props.user.user_type))
      return props.children;
    return null
  }
  if (props.allow.includes(props.user.user_type))
    return null;
  return props.children;

};


//<Role allow={["admin", "manager"]} user={user}><li><a href="#">Hotsheets</a></li></Role>


export const nameCode = (first, last) => {
  if (first && last)
    return first[0] + last[0]
}
export const pagination = Pagination;
pagination.defaultPageSize = 25;


export const CopyGenerator = ($this) => {
  const form = $this.props.form;
  const generator = form.getFieldValue('generator');
  let account_number;
  if (generator) {
    GeneratorGet(generator)
      .then(response => {
        account_number = response.data.account_number;
        BillToList({account_number: account_number})
          .then(response1 => {
            response1 = response1.data.results;
            if (response1.length) {
              response = response1[0];
              $this.bill_to.handleChange({
                key: response.id,
                label: `${response.company_name} ${response.account_number}`
              });
            }
            else {
              BillToPost(response.data)
                .then(response => {
                  $this.bill_to.handleChange({
                    key: response.id,
                    label: `${response.company_name} ${response.account_number}`
                  });
                })
            }
          })
      })
  }
}

export const FillBillToOnGeneratorChange = (generator_id, $this) => {
  GeneratorGet(generator_id)
    .then(response => {
      if (response.data.bill_to_rel.length) {
        const data = response.data.bill_to_rel[0]
        $this.bill_to.handleChange({
          key: data.id,
          label: `${data.company_name} ${data.account_number}`
        });
      }
    })
}
export const toList = (dict) => {
    return Object.keys(dict).map(function (key) {
        let data = {}
        data[key] = dict[key]
        return data
    });
}


export const download = (path, filename) => {
    const anchor = document.createElement('a');
    anchor.href = path;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
};


// WEBPACK FOOTER //
// ./src/controller/Utils.jsx